import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        keyword: null,
        channelId: null, //ChannelID
        UserCheck: null,
        userId: null, //USID
        Uid: null //basicID
    },
    actions: {
        // 使用liff 獲取使用者資料
        getUserid(state, user){
            liff.init(function (data) {
                let userid = data.context.userId
                state.commit('getUserid', userid)
            })
        },
        getApi (state, contents) {
            // <回覆訊息>
            setTimeout(() => {
                let keyword = contents.keyword
                let channelId = contents.c
                //alert('chann: ' + contents.c)
                //alert('getApi_userId:' + this.getters.userId)

                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/LIFFCardReply'
                let postData = {
                    "KeyWord": keyword,
                    "ChannelID": channelId,
                    "USID": this.getters.userId
                }
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    console.log(res)
                    //alert(res)  //[object object]
                });
            },2000);

            // <導至對話框>2s
            setTimeout(function () {
                document.getElementById('auto').click();
            }, 2000);
        },
        // 開啟即自動偵測是否已加入好友
        getAutoclick (state, contents) {
            setTimeout(() => {
                let channelId = contents.c
                //alert('userID: ' + this.getters.userId)

                let apiUrl = 'https://api-linebiz.eilis-ai.com/app/USIDCheck'
                let postData = {
                    "USID": this.getters.userId,
                    "ChannelID": channelId
                }
                state.commit('statecontent', postData)
                return axios.post(apiUrl, postData)
                .then((response) => {
                    return response
                })
                .then((result) => {
                    //alert(JSON.stringify(result.data));
                    state.UserCheck = result.data //result.data: true or false
                    //alert("state_UserCheck" + state.UserCheck)
                    state.commit('liffAlert', result.data)
                    if (result.data == false) {
                        document.getElementById("auto").click()
                    }
                });
            },1500);
        },
        // 取得basicID //
        getID (state, contents) {
            setTimeout(() => {
                //alert("re_c:" + contents.c)
                let channelId = contents
                let apiUrl = 'https://tc-line-bot-test.herokuapp.com/app/GetBasicID'
                let postData = {
                    "ChannelID": channelId
                }
                console.log(postData)
                return axios.post(apiUrl, postData) 
                
                .then((res) => {
                    console.log(res)
                    //alert(JSON.stringify(res))
                    state.commit('getID', res.data.Report)
                });
            },800);
        }
    },
    getters: {
        userId(state) {
            return state.userId
        },
        Uid(state) {
            return state.Uid
        }
    },
    mutations: {
        getUserid(state, user) {
            state.userId = user
            //alert("mu_userid:" + state.userId)
        },
        statecontent(state, postData) {
            state.channelId = postData.ChannelID
            //alert(state.channelId)
        },
        liffAlert(state, check) {
            state.UserCheck = check
            //alert("mu_usercheck:" + check)
        },
        getID(state, contents) {
            state.Uid = contents
            //alert("id:" + state.Uid)
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js